import { render, staticRenderFns } from "./profession.vue?vue&type=template&id=cd0cbaf8&scoped=true"
import script from "./profession.vue?vue&type=script&lang=ts"
export * from "./profession.vue?vue&type=script&lang=ts"
import style0 from "./profession.vue?vue&type=style&index=0&id=cd0cbaf8&prod&lang=scss&scoped=true"
import style1 from "./profession.vue?vue&type=style&index=1&id=cd0cbaf8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd0cbaf8",
  null
  
)

export default component.exports